import React from 'react';
import { connect } from 'react-redux';

import WaitingForPayment from './waitingForPayment.jsx';
import VerificationRequired from './verificationRequired.jsx';

import { data as agreementDataPropTypes } from '../../../agreementPropTypes.js';
import partnerPropTypes from '../../../partnerPropTypes.js';
import userPropTypes from '../../../userPropTypes.js';

const AgreementAcceptedDetails = ({ agreement, partner, user }) => {
    if (user.verificationStatus === 'NOT_VERIFIED') {
        return <VerificationRequired user={user} />;
    }

    return <WaitingForPayment agreement={agreement} partner={partner} />;
};

AgreementAcceptedDetails.propTypes = {
    agreement: agreementDataPropTypes.isRequired,
    partner: partnerPropTypes.isRequired,
    user: userPropTypes.isRequired,
};

function mapStateToProps(state) {
    return {
        agreement: state.agreement.data,
        partner: state.partner,
        user: state.user,
    };
}

export default connect(mapStateToProps)(AgreementAcceptedDetails);



// WEBPACK FOOTER //
// ./safeTrade/seller/agreement/statusDetails/agreementAcceptedDetails.jsx